import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PostHogPageview from "./PostHogPageview";
import { Analytics } from "@vercel/analytics/react";
import AppHeader from "./components/AppHeader";
import Home from "./pages/Home";
import CaptionsModule from "./components/CaptionsModule";
import ImagePrompts from "./components/ImagePrompts";
import BrandSettings from "./components/BrandSettings";
import BuyCredits from "./components/BuyCredits";
import Login from "./pages/Login";
import RequireAuth from "./auth/RequireAuth";
import ResetPassword from "./pages/ResetPassword";
import BlogModule from "./components/BlogModule";
import PrewritingModule from "./components/PrewritingModule";
import Privacy from "./pages/Privacy";

//const { user } = useAuth();
//console.log("AUTH USER:", user?.id, user?.email);

function App() {
  return (
    <Router>
      <PostHogPageview />
      <div className="min-h-screen bg-gray-50">
        {/* Header always visible */}
        <AppHeader />

        <main className="max-w-4xl mx-auto px-4 py-6 sm:py-8">
          <Routes>
            {/* Login Page */}
            <Route path="/login" element={<Login />} />

            {/* Home Page */}
            <Route path="/" element={<Home />} />

            {/* Social modules */}
            <Route path="/captions" element={
              <RequireAuth>
                <CaptionsModule />
              </RequireAuth>
            } />

            <Route path="/blog" element={
              <RequireAuth>
                <BlogModule />
              </RequireAuth>
            } />
            
            <Route path="/prewriting" element={
              <RequireAuth>
                <PrewritingModule />
              </RequireAuth>
            } />


            {/* Image Prompts Page */}
            <Route path="/images" element={
              <RequireAuth>
                <ImagePrompts />
              </RequireAuth>
            } />

            {/* Brand Settings */}
            <Route path="/settings" element={
              <RequireAuth>
                <BrandSettings />
              </RequireAuth>
            } />
            <Route path="/buy-credits" element={<BuyCredits />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Privacy notice (public) */}
            <Route path="/privacy" element={<Privacy />} />


            {/* Future routes go here */}
          </Routes>
        </main>
      </div>
      <Analytics/>
    </Router>
  );
}

export default App;
